import { getDeliveryWindowPriority } from "./Util";
import {
  getOverviewStatusPriority,
  isRouteStaged,
  PENDING_DEPART,
} from "../../outboundAmzl/RouteStatusManager";
import { LOCATION_TYPE } from "../../outboundAmzl/util/Constants";
import { INTERIM_STAGED } from "./Constants";

export function createRouteWaveList(routeList) {
  let routeWaveList = [];
  //create route with common window and length
  routeList.forEach((route) => {
    const wave = routeWaveList.find((wave) => {
      return (
        wave.name === route.deliveryWindow && wave.length === route.routeLength
      );
    });
    if (wave) {
      wave.routeList.push(route);
    } else {
      routeWaveList.push({
        name: route.deliveryWindow,
        length: route.routeLength,
        key: route.deliveryWindow + route.routeLength,
        routeList: [route],
      });
    }
  });
  //sort according to window and decreasing length
  routeWaveList = routeWaveList.sort((a, b) => {
    const deliveryWindowPriorityA = getDeliveryWindowPriority(a.name);
    const deliveryWindowPriorityB = getDeliveryWindowPriority(b.name);
    if (deliveryWindowPriorityA === deliveryWindowPriorityB) {
      return b.length - a.length;
    } else {
      return deliveryWindowPriorityA - deliveryWindowPriorityB;
    }
  });
  //sort according to CPT
  sortRoutesAccordingToCPT(routeWaveList);

  return routeWaveList;
}

function sortRoutesAccordingToCPT(routeWaveList) {
  routeWaveList.forEach((wave) => {
    wave.routeList.sort((a, b) => {
      const statusPriorityA = getOverviewStatusPriority(a.overviewStatus);
      const statusPriorityB = getOverviewStatusPriority(b.overviewStatus);
      if (statusPriorityA === statusPriorityB) {
        return a.criticalPullTime - b.criticalPullTime;
      } else {
        return statusPriorityA - statusPriorityB;
      }
    });
  });
}

export function createRouteWaveListForSSDMMOT(routeList) {
  let routeWaveList = [];
  //create route with common window and length
  routeList.forEach((route) => {
    const wave = routeWaveList.find((wave) => {
      return wave.name === route.deliveryWindow;
    });
    if (wave) {
      wave.routeList.push(route);
    } else {
      routeWaveList.push({
        name: route.deliveryWindow,
        key: route.deliveryWindow,
        routeList: [route],
      });
    }
    if (route.overviewStatus === PENDING_DEPART && !isRouteStagedAtDD(route)) {
      route.overviewStatus = INTERIM_STAGED;
    }
  });
  //sort according to window
  routeWaveList = routeWaveList.sort((a, b) => {
    return (
      getDeliveryWindowPriority(a.name) - getDeliveryWindowPriority(b.name)
    );
  });
  //sort according to CPT
  sortRoutesAccordingToCPT(routeWaveList);
  return routeWaveList;
}

export function createDockDoorRouteMap(routeList) {
  let dockDoorRouteMap = new Map();
  routeList.forEach((route) => {
    if (isRouteStaged(route)) {
      const dockDoor = getDockDoor(route);
      if (dockDoor) {
        const dockDoorLabel = dockDoor.label;
        if (!dockDoorRouteMap.get(dockDoorLabel)) {
          dockDoorRouteMap.set(dockDoorLabel, [route]);
        } else {
          dockDoorRouteMap.get(dockDoorLabel).push(route);
        }
      }
    }
  });
  return dockDoorRouteMap;
}

export function createAnchorPointRouteMap(routeList) {
  let anchorPointRouteMap = new Map();
  routeList.forEach((route) => {
    const anchorPoint = route.sourceNode;
    if (!anchorPointRouteMap.get(anchorPoint)) {
      anchorPointRouteMap.set(anchorPoint, [route]);
    } else {
      anchorPointRouteMap.get(anchorPoint).push(route);
    }
  });
  return anchorPointRouteMap;
}

export function getDockDoor(route) {
  let stagingLocation;
  if (
    Array.isArray(route.stagingLocations) &&
    route.stagingLocations.length !== 0
  ) {
    stagingLocation = route.stagingLocations.find((stagingLocation) => {
      return stagingLocation.locationType === LOCATION_TYPE.DOCK_DOOR;
    });
  }
  return stagingLocation;
}

function isRouteStagedAtDD(route) {
  let isRouteStaged = false;
  route.stagingLocations.forEach((stagingLocation) => {
    if (stagingLocation.locationType === LOCATION_TYPE.DOCK_DOOR) {
      isRouteStaged = true;
    }
  });
  return isRouteStaged;
}



// WEBPACK FOOTER //
// ./src/components/outboundSSD/util/CreateRouteWaveList.js